export class Routes {
  // POST
  static saveGoogleMapsCredentials = (companyUuid: string): string => `/api/google-maps/credential/${companyUuid}`
}
